import React from 'react';
import { Link } from 'react-router';

class BottomNav extends React.Component {
	render() {
		const { setCurrentPage, currentPage } = this.props;
		return (
			<div className="bottom-nav">
				<Link 
					to="/business"
					onClick={() => setCurrentPage('business')}>
					<button className={currentPage === 'business'? 'bottom-nav--active': ''}>
						Business
					</button>
				</Link>
				<Link
					to="/app"
					onClick={() => setCurrentPage('app')}>
					<button className={currentPage === 'app'? 'bottom-nav--active': ''}>
						App
					</button>
				</Link>
				<a href="mailto:sinan@baggid.com?Subject=Mensaloesung" target="_blank" rel="noopener noreferrer">
					<button>Kontakt</button>
				</a>
				<Link
					to="/imprint"
					onClick={() => setCurrentPage('imprint')}>
					<button className={currentPage === 'imprint'? 'bottom-nav--active': ''}>
						Imprint
					</button>
				</Link>
			</div>
		);
	}
}

export default BottomNav;


// WEBPACK FOOTER //
// ./src/gui/BottomNav.js